export const inject = (src: string, id: string): Promise<void> =>
  new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      return resolve();
    }

    const script = document.createElement('script');

    const onScriptLoad = () => {
      resolve();
    };

    const onScriptLoadError = () => {
      reject(new Error(`Failed to load ${src}`));
    };

    script.type = 'text/javascript';
    script.src = src;
    script.id = id;
    script.async = true;
    script.defer = true;
    script.onerror = onScriptLoadError;
    script.onload = onScriptLoad;

    document.body.appendChild(script);
  });
